/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { colors as CCColors } from '@blend/consumer-components';
import { BrandColors } from '@blend/enterprise-components';

const baseColors = {
  blackPearl: '#060E2B',
  lightGreen: '#00E5BF',
  blue: 'blue',
  infoLight08: '#EFFCFF',
  infoDark33: '#22648B',
  pinkDark33: '#8F388E',
  pinkLight08: 'linear-gradient(0deg, rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0.92)), #C942AD',
};

const consumerBaseColors = { ...CCColors, ...baseColors };

const enterpriseBaseColors = { ...BrandColors, ...baseColors };

export const consumerColors = { ...consumerBaseColors, action: consumerBaseColors.reflex };

export const enterpriseColors = { ...enterpriseBaseColors };

export type ConsumerColors = typeof consumerColors;

export type EnterpriseColors = typeof enterpriseColors;
